export default __webpack_public_path__ + "static/blue_fish_desktop-9a79c702664e34c6cf7685600e78fa07.png";